import { Logo } from "~/icons";
import { useNavigationStore } from "~/stores";
import { UserInformation } from "../UserInformation";
import { NavigationItems } from "./NavigationItems";
import { UserDrawerNavigation } from "./UserNavigation";

export const NavigationDrawer = () => {
  const closeSidebar = useNavigationStore((state) => state.closeSidebar);

  return (
    <div className="flex grow flex-col justify-between gap-y-5 overflow-y-auto bg-white">
      <div className="flex flex-col gap-y-5 px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center">
          <Logo handleOnClick={closeSidebar} className="md:h-9" />
        </div>
        <nav className="flex flex-1 flex-col">
          <ul role="list" className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul role="list" className="space-y-1">
                <NavigationItems />
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div className="block lg:hidden">
        <UserInformation className="px-6 pb-4" />

        <hr className="border-neutral-400" />

        <UserDrawerNavigation />
      </div>
    </div>
  );
};
